const $doc = $(document)

$doc.on('click', '.js-link-copy', function (e) {
  e.preventDefault()
  const $this = $(this)
  const copyText = $this.attr('href')
  const $input = $('<input class="js-copy-clipboard">')
  $this.append($input)
  $this.find('input').val(copyText).select()
  document.execCommand('copy')
  $this.find('input').remove()

  if (!$this.attr('data-tooltip-text')) {
    $this.attr('data-tooltip-text', 'Copied!')
  }

  $this.addClass('is-tooltip-show')

  const removeDataAttr = setTimeout(function () {
    $this.removeClass('is-tooltip-show')
  }, 2000)
})
